export const portfolio = [
    {
        name: "Exoqual",
        id: "Exoqual",
    },
    {
        name: "AngelsAndDemons",
        id: "AngelsAndDemons",
    },
    {
        name: "Dca",
        id: "Dca",
    },
    {
        name: "Robotto",
        id: "Robotto",
    },
    {
        name: "BatGirl",
        id: "BatGirl",
    },
    {
        name: "Iggy",
        id: "Iggy",
    },
    {
        name: "Zappyeels",
        id: "Zappyeels",
    },
    {
        name: "wmcdacktpa",
        id: "Wmcdacktpa",
    },
    {
        name: "ttf",
        id: "Ttf",
    },
    {
        name: "Rexit",
        id: "Rexit",
    },
    {
        name: "Classy Essay Writer",
        id: "ClassyEssayWriter",
    },
    {
        name: "Custom Written Papers",
        id: "CustomWrittenPapers",
    },
    {
        name: "Essay Writing Services",
        id: "EssayWritingServices",
    },
    {
        name: "Take My Exam",
        id: "TakeMyExam",
    },
];
